/**
 * GA4 measurement IDs and Google Consent Mode defaults for profile microsites.
 */
import { getGa4MeasurementIdProfile } from './profileAnalytics';

export const GA4_MEASUREMENT_ID_PROFILE = getGa4MeasurementIdProfile();

export const GA4_CONSENT_DEFAULTS = {
  analytics_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
};

export const GA4_CONSENT_GRANTED = {
  analytics_storage: 'granted',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
};

/** Google gtag stub — must push `arguments`, not a rest-params array (Consent Mode queue shape). */
function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    // eslint-disable-next-line prefer-rest-params -- matches Google snippet / OEServer analytics-config.js
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
  }
}

/** Call before gtag.js loads so Didomi GCM v2 can update consent later. */
export function installGa4ConsentDefaults() {
  ensureGtagStub();
  window.gtag('consent', 'default', GA4_CONSENT_DEFAULTS);
}

export function grantGa4Consent() {
  ensureGtagStub();
  window.gtag('consent', 'update', GA4_CONSENT_GRANTED);
}

/** Sencha revokeGa4ConsentMode — stop GA4 storage when analytics is off. */
export function revokeGa4ConsentMode() {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('consent', 'update', GA4_CONSENT_DEFAULTS);
}

installGa4ConsentDefaults();

/** Resolve at call time so Redux/JSP config wins after profile load. */
export function getGa4MeasurementId() {
  return getGa4MeasurementIdProfile();
}
